export const calculateOrderTotal = (order: IOrder) =>
  order?.items?.reduce((acc, item) => acc + parseFloat(item.itemSummaryDisplayAmount), 0);
